module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAZlBMVEVHcEw2ZKM1ZKL9/v41ZKM1ZKLb4+41ZKI1ZKIzYqEvYJ8rXZ4wYKAoWpz///9KdayAncWftdM1ZKL2+PuMp8pDbqhVfLFmirnc5O+Wrs/O2ejH0+W1xt3i6PI4ZqN9m8Ps8Panu9YO0pQCAAAACXRSTlMAhP3+iIz9/vrCdvaTAAAA1klEQVR4Xu3RubLCMAxAUZ7DI5Ylb9nZ4f9/ksSpcKNoAIYit5KLM/ZYm++19qcVk95mRFdsOiMlT8qMqLcRY1O0mBjsQoxx33S0kKA/1S7V2GXE+LNzIgJ0dEKCvZMSG91UfYox9mYRwfSuohd8sjlM5HyBdBKQ4YOEEK2dCVpEBJZAF0K4pkXewnWcW+CI3bvnOiMlN/ktQyUmR6xY0tRjRdr+NN15Aq33vp2376cRWFIBEWEiAxgieGX7v09WUsqJ5onKyFarLHMoxnYXUHP6f/O11h74llB3oTAFJgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/sns_facebook.png
// module id = T9yW
// module chunks = 1